import { useEffect, useRef, useState } from "react";
import Swal from "sweetalert2";

interface UseCachedWorkOrderOpenOptions {
  loading: boolean;
  hasData: boolean;
}

export function useCachedWorkOrderOpen({
  loading,
  hasData,
}: UseCachedWorkOrderOpenOptions) {
  const [showDialog, setShowDialog] = useState(false);
  const [selectedWorkOrderId, setSelectedWorkOrderId] = useState<number | null>(
    null,
  );
  const cachedWorkOrderProcessed = useRef(false);

  useEffect(() => {
    if (loading || !hasData) return;

    if (cachedWorkOrderProcessed.current || showDialog) return;

    const cachedWorkOrderId = localStorage.getItem("cachedNewWorkOrderId");
    const cachedDocumentNumber = localStorage.getItem(
      "cachedNewWorkOrderDocumentNumber",
    );

    if (!cachedWorkOrderId) return;

    const workOrderId = parseInt(cachedWorkOrderId, 10);
    if (isNaN(workOrderId)) return;

    cachedWorkOrderProcessed.current = true;

    Swal.fire({
      title: "Work Order Saved",
      html: `Work Order #${cachedDocumentNumber} has been Saved successfully and will now open for you.`,
      icon: "success",
      confirmButtonColor: "#2371E7",
      confirmButtonText: "OK",
      allowOutsideClick: false,
    }).then(() => {
      localStorage.removeItem("cachedNewWorkOrderId");
      localStorage.removeItem("cachedNewWorkOrderDocumentNumber");
      setSelectedWorkOrderId(workOrderId);
      setShowDialog(true);
    });
  }, [loading, hasData, showDialog]);

  useEffect(() => {
    if (!showDialog) {
      cachedWorkOrderProcessed.current = false;
    }
  }, [showDialog]);

  const showHideWorkOrderPopup = (isPopupToShow: boolean) => {
    setShowDialog(isPopupToShow);
    if (!isPopupToShow) {
      setSelectedWorkOrderId(null);
    }
  };

  return {
    showDialog,
    selectedWorkOrderId,
    showHideWorkOrderPopup,
  };
}
